import { render, staticRenderFns } from "./hair_2.vue?vue&type=template&id=95776638&scoped=true&"
import script from "./hair_2.vue?vue&type=script&lang=js&"
export * from "./hair_2.vue?vue&type=script&lang=js&"
import style0 from "./hair_2.vue?vue&type=style&index=0&id=95776638&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95776638",
  null
  
)

export default component.exports